<template>
  <div id="post-list-component">
    <div class="row row-cards">
      <template v-if="isNotFound(items) && !busy">
        <span class="items-not-found">Ничего не найдено</span>
      </template>
      <template v-else>
        <div class="col-lg-4 col-sm-6" v-for="item in items" :key="item['id']">
          <div class="card" :class="getClassBg(item)">
            <template v-if="row.isChannelSite(item)">
              <div class="post-site" :class="getClassByTypeId(item)">
                <template v-if="row.isPrePublished(item) || row.isPreDeleted(item) || row.isCanceled(item)">
                  <div class="ribbon bg-warn">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-alert-circle-filled" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                      <path d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm.01 13l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z" stroke-width="0" fill="currentColor"/>
                    </svg>
                    <span v-if="row.isPrePublished(item)">Публикуется...</span>
                    <span v-if="row.isPreDeleted(item)">Выключается...</span>
                    <span v-if="row.isCanceled(item)">Отменен</span>
                  </div>
                </template>

                <template v-if="row.isDraft(item)">
                  <div class="ribbon bg-secondary">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-pencil" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <path d="M4 20h4l10.5 -10.5a1.5 1.5 0 0 0 -4 -4l-10.5 10.5v4"></path>
                      <path d="M13.5 6.5l4 4"></path>
                    </svg> <span v-html="row.getCreatedAt(item)"></span>
                  </div>
                </template>

                <template v-if="row.isDeleted(item)">
                  <div class="ribbon bg-red">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-trash" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <line x1="4" y1="7" x2="20" y2="7"></line>
                      <line x1="10" y1="11" x2="10" y2="17"></line>
                      <line x1="14" y1="11" x2="14" y2="17"></line>
                      <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
                      <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
                    </svg> <span v-html="row.getRemovedAt(item)"></span>
                  </div>
                </template>

                <template v-else-if="row.isScheduled(item)">
                  <div class="ribbon bg-yellow">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-clock-hour-8" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <circle cx="12" cy="12" r="9"></circle>
                      <path d="M12 12l-3 2"></path>
                      <path d="M12 7v5"></path>
                    </svg> <span v-html="row.getScheduledPublished(item)"></span>
                  </div>
                </template>

                <template v-else-if="row.isViewScheduledRemoved(item)">
                  <div class="ribbon bg-flickr">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-flame" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 12c2 -2.96 0 -7 -1 -8c0 3.038 -1.773 4.741 -3 6c-1.226 1.26 -2 3.24 -2 5a6 6 0 1 0 12 0c0 -1.532 -1.056 -3.94 -2 -5c-1.786 3 -2.791 3 -4 2z" /></svg>
                    <span v-html="row.getScheduledRemoved(item)"></span>
                  </div>
                </template>

                <div class="close-full-show" v-if="isMoreShowSite(item['id'])" @click.prevent="onMoreHideSite(item['id'])">
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M18 6l-12 12"></path>
                    <path d="M6 6l12 12"></path>
                  </svg>
                </div>

                <template v-if="row.isTypeSales(item)">
                  <span>
                    <div class="card-img-top card-img-hover" @click.prevent="onMoreShowHideSite(item['id'])" :class="{ 'card-img-top_show': isMoreShowSite(item['id']) }">
                      <div class="row">
                        <div class="col-6">
                          <template v-if="row.hasImages(item)">
                            <img :src="getPostImage(item, null, 300)" class="img-card">
                          </template>
                          <template v-else>
                            <img width="500" :src="getImageStub(false)" class="img-card">
                          </template>
                        </div>
                        <div class="col-6">
                          <div class="post-info" :class="{ 'no-badge': !hasBadge(item) }">
                            <ul>
                              <li>
                                {{ row.getTypeVisibility(item) }}
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-eye"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" /><path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" /></svg>
                              </li>
                              <li v-if="row.hasTimeAction(item)">
                                {{ row.getTimeAction(item) }}
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-calendar-event"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 5m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" /><path d="M16 3l0 4" /><path d="M8 3l0 4" /><path d="M4 11l16 0" /><path d="M8 15h2v2h-2z" /></svg>
                              </li>
                              <li v-if="row.hasPromocode(item)">
                                {{ row.getPromocode(item) }}
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-discount"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 15l6 -6" /><circle cx="9.5" cy="9.5" r=".5" fill="currentColor" /><circle cx="14.5" cy="14.5" r=".5" fill="currentColor" /><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" /></svg>
                              </li>
                               <li v-if="row.hasCategoryName(item)">
                                {{ row.getCategoryName(item) }}
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-folders"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 3h3l2 2h5a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2" /><path d="M17 16v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2" /></svg>
                              </li>
                              <li v-if="row.hasShop(item)">
                                {{ row.getShopName(item) }}
                                <img class="shop-image" width="15" :src="row.getShopImage(item, 30)">
                              </li>
                               <li v-if="row.hasSaleTypeId(item)">
                                {{ row.getSaleTypeIdName(item) }}
                                 <template v-if="row.hasPrice(item)">
                                  {{ row.getPrice(item) }}
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-coin"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" /><path d="M14.8 9a2 2 0 0 0 -1.8 -1h-2a2 2 0 1 0 0 4h2a2 2 0 1 1 0 4h-2a2 2 0 0 1 -1.8 -1" /><path d="M12 7v10" /></svg>
                                 </template>
                                 <template v-else>
                                    {{ row.getSaleTypeValue(item) }}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-database-dollar">
                                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                      <path d="M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3" />
                                      <path d="M4 6v6c0 1.657 3.582 3 8 3c.415 0 .822 -.012 1.22 -.035" />
                                      <path d="M20 10v-4" />
                                      <path d="M4 12v6c0 1.657 3.582 3 8 3c.352 0 .698 -.009 1.037 -.025" />
                                      <path d="M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5" />
                                      <path d="M19 21v1m0 -8v1" />
                                    </svg>
                                 </template>
                              </li>
                              <li v-if="row.hasActivateLink(item)">
                                Ссылка
                                <a class="activate-link" :href="row.getActivateLink(item)" target="_blank" @click.stop>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-link">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M9 15l6 -6" />
                                    <path d="M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464" />
                                    <path d="M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463" />
                                  </svg>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card-body post-item" @click="onMoreShowSite(item['id'])">
                      <div class="card-info">
                        <TypeCommerce :data="{
                          value: row.getTypeCommerce(item)
                        }" />
                        <PostSaleStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <PostPointRatingStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <PostPointChainRatingStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <PostRatingStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <CntComments :payload="{
                          cnt_comments: row.getCntComments(item),
                        }" />
                      </div>
                      <div class="text-muted title-post">{{ row.getTitle(item) }}</div>
                      <div class="text-muted text-long" v-show="isMoreShowSite(item['id'])" v-html="item['content_long']"></div>
                      <div class="text-muted card-text-sh" v-show="!isMoreShowSite(item['id'])" v-html="item['content_short']"></div>
                      <div class="my-2">
                        <template v-if="PostPermission.isUpdate(row.getChannelId(item))">
                          <router-link :to="{ name: 'PostUpdate', params: { id: item['id'] } }" class="edit-post toggle-show-post" @click.prevent="onMoreShowSite(item['id'])">Редактировать</router-link>
                        </template>
                        <template v-else>
                          <router-link :to="{ name: 'PostView', params: { id: item['id'] } }" class="edit-post toggle-show-post" @click.prevent="onMoreShowSite(item['id'])">Смотреть</router-link>
                        </template>
                      </div>
                    </div>
                  </span>
                </template>

                <template v-if="row.isTypeArticles(item)">
                  <span>
                    <div class="card-img-top card-img-hover" @click.prevent="onMoreShowHideSite(item['id'])" :class="{ 'card-img-top_show': isMoreShowSite(item['id']) }">
                      <div class="row">
                        <div class="col-6">
                          <template v-if="row.hasImages(item)">
                            <img :src="getPostImage(item, null, 300)" class="img-card">
                          </template>
                          <template v-else>
                            <img width="500" :src="getImageStub(false)" class="img-card">
                          </template>
                        </div>
                        <div class="col-6">
                          <div class="post-info" :class="{ 'no-badge': !hasBadge(item) }">
                            <ul>
                              <li v-if="row.hasShop(item)">
                                {{ row.getShopName(item) }}
                                <img class="shop-image" width="15" :src="row.getShopImage(item, 30)">
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card-body post-item" @click="onMoreShowSite(item['id'])">
                      <div class="card-info">
                        <TypeCommerce :data="{
                          value: row.getTypeCommerce(item)
                        }" />
                        <PostSaleStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <PostPointRatingStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <PostPointChainRatingStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <PostRatingStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <CntComments :payload="{
                          cnt_comments: row.getCntComments(item),
                        }" />
                      </div>
                      <div class="text-muted title-post">{{ row.getTitle(item) }}</div>
                      <div class="text-muted text-long" v-show="isMoreShowSite(item['id'])" v-html="item['content_long']"></div>
                      <div class="text-muted card-text-sh" v-show="!isMoreShowSite(item['id'])" v-html="item['content_short']"></div>
                      <div class="my-2">
                        <template v-if="PostPermission.isUpdate(row.getChannelId(item))">
                          <router-link :to="{ name: 'PostUpdate', params: { id: item['id'] } }" class="edit-post toggle-show-post" @click.prevent="onMoreShowSite(item['id'])">Редактировать</router-link>
                        </template>
                        <template v-else>
                          <router-link :to="{ name: 'PostView', params: { id: item['id'] } }" class="edit-post toggle-show-post" @click.prevent="onMoreShowSite(item['id'])">Смотреть</router-link>
                        </template>
                      </div>
                    </div>
                  </span>
                </template>

                <template v-else-if="row.isTypeNotes(item)">
                  <div class="close-full-show" :class="{ 'right': !hasBadge(item) }" v-if="isMoreShowTelegram(item['id'])" @click.prevent="onMoreHideTelegram(item['id'])">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <path d="M18 6l-12 12"></path>
                      <path d="M6 6l12 12"></path>
                    </svg>
                  </div>
                  <span>
                    <div class="card-body post-item">
                      <div class="text-muted text-long" v-show="isMoreShowTelegram(item['id'])" v-html="item['content_long']"></div>
                      <div class="text-muted card-text-sh" v-show="!isMoreShowTelegram(item['id'])" v-html="item['content_short']"></div>
                      <div class="my-2">
                        <template v-if="row.isViewModerateNotes(item)">
                          <div class="row">
                            <div class="col-6">
                              <template v-if="PostPermission.isUpdate(row.getChannelId(item))">
                                <router-link :to="{ name: 'PostUpdate', params: { id: item['id'] } }" class="edit-post toggle-show-post" @click.prevent="onMoreShowTelegram(item['id'])">Редактировать</router-link>
                              </template>
                              <template v-else>
                                <router-link :to="{ name: 'PostView', params: { id: item['id'] } }" class="edit-post toggle-show-post" @click.prevent="onMoreShowTelegram(item['id'])">Смотреть</router-link>
                              </template>
                            </div>
                            <div class="col-6">
                             <template v-if="PostPermission.isUpdate(row.getChannelId(item))">
                               <a href="#" class="moderate-post toggle-show-post" @click.prevent="onMarkPostModerate(item['id'])">Проверить</a>
                             </template>
                            </div>
                          </div>
                        </template>
                        <template v-else>
                          <template v-if="PostPermission.isUpdate(row.getChannelId(item))">
                            <router-link :to="{ name: 'PostUpdate', params: { id: item['id'] } }" class="edit-post toggle-show-post" @click.prevent="onMoreShowTelegram(item['id'])">Редактировать</router-link>
                          </template>
                          <template v-else>
                            <router-link :to="{ name: 'PostView', params: { id: item['id'] } }" class="edit-post toggle-show-post" @click.prevent="onMoreShowTelegram(item['id'])">Смотреть</router-link>
                          </template>
                        </template>
                      </div>
                    </div>

                    <div class="card-img-top card-img-hover" @click.prevent="onMoreShowHideTelegram(item['id'])" :class="{ 'card-img-top_show': isMoreShowTelegram(item['id']) }">
                     <template v-if="row.hasImages(item)">
                        <div class="img-card">
                          <span
                              v-for="image in getImages(item, 200, 200)"
                              :key="image.name"
                              class="img-wrapper"
                          >
                            <img :src="image" />
                          </span>
                        </div>
                      </template>
                      <template v-else>
                        <div class="img-card">
                          <span class="img-wrapper">
                            <img width="500" :src="getImageStub(false)">
                          </span>
                        </div>
                      </template>
                      <div class="card-info">
                        <PostSaleStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <PostPointRatingStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <PostPointChainRatingStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <PostRatingStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <CntComments :payload="{
                          cnt_comments: row.getCntComments(item),
                        }" />
                      </div>
                    </div>
                  </span>
                </template>

                <template v-else-if="row.isTypePromocode(item)">
                  <span>
                    <div class="card-img-top card-img-hover" @click="onMoreShowHideSite(item['id'])" :class="{ 'card-img-top_show': isMoreShowSite(item['id']) }">
                      <img src="/assets/static/promopushka/no_image.jpg" class="img-card">
                      <div class="card-img-wrap">
                        <template v-if="row.hasShop(item)">
                          <img :src="row.getShopImage(item, 300, 300)" class="img-card-image">
                        </template>
                        <template v-else>
                          <img width="300" :src="getImageStub(false)" class="img-card-image">
                        </template>
                        <div>
                          <b>{{ row.getTitle(item) }}</b>
                         <div class="mt-1">
                            <template v-if="row.hasPromocode(item)">
                              <span class="icon-api me-1" v-if="row.isPromocodeApi(item)">
                                <IconApi/>
                              </span>
                              <span class="badge bg-purple">{{ row.getPromocode(item) }}</span>
                            </template>
                            <template v-if="row.hasActivateLink(item)">
                              <span class="ms-1">
                                <a class="activate-link" :href="row.getActivateLink(item)" target="_blank" @click.stop>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-link">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M9 15l6 -6" />
                                    <path d="M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464" />
                                    <path d="M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463" />
                                  </svg>
                                </a>
                              </span>
                            </template>
                          </div>
                        </div>
                      </div>
                      <div class="card-info">
                        <TypeCommerce :data="{
                          value: row.getTypeCommerce(item)
                        }" />
                        <PostSaleStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <PostPointRatingStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <PostPointChainRatingStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <PostRatingStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <CntComments :payload="{
                          cnt_comments: row.getCntComments(item),
                        }" />
                      </div>
                    </div>
                    <div class="card-body post-item" @click="onMoreShowSite(item['id'])">
                      <div class="text-muted text-long" v-show="isMoreShowSite(item['id'])" v-html="item['content_long']"></div>
                      <div class="text-muted card-text-sh" v-show="!isMoreShowSite(item['id'])" v-html="item['content_short']"></div>
                      <div class="my-2">
                        <template v-if="PostPermission.isUpdate(row.getChannelId(item))">
                          <router-link :to="{ name: 'PostUpdate', params: { id: item['id'] } }" class="edit-post toggle-show-post" @click.prevent="onMoreShowSite(item['id'])">Редактировать</router-link>
                        </template>
                        <template v-else>
                          <router-link :to="{ name: 'PostView', params: { id: item['id'] } }" class="edit-post toggle-show-post" @click.prevent="onMoreShowSite(item['id'])">Смотреть</router-link>
                        </template>
                      </div>
                    </div>
                  </span>
                </template>

                <div class="card-footer">
                  <div class="d-flex align-items-center">
                    <span class="avatar me-3" :style="{ backgroundImage: 'url(' + getImage(item['user_source']['avatar']['host'], item['user_source']['avatar']['name'], 60) + ')' }"></span>
                    <div class="author">
                      <div class="author__name">
                        {{ item['user_source']['username'] }}
                      </div>
                      <div class="channel">
                        <span class="me-2">
                          <Channel :data="{
                            channel_id: row.getChannelId(item)
                          }" />
                        </span>
                        <span class="author__real_name" v-if="item['post_user_phantom'] === true">
                          <span class="avatar me-1" :style="{ backgroundImage: 'url(' + getImage(item['user_avatar_host'], item['user_avatar_name'], 60) + ')' }"></span>
                          <span class="username">
                            {{ item['username'] }}
                          </span>
                        </span>
                      </div>
                    </div>

                    <div class="ms-auto text-right" v-if="row.isPublished(item)">
                      <div>Опубликовано:</div>
                      <div class="text-muted" v-html="row.getPublishedAt(item)"></div>
                    </div>

                    <div class="ms-auto text-right" v-if="row.isPrePublished(item)">
                      <div>Публикуется...</div>
                      <div class="text-muted" v-if="row.getScheduledPublished(item)" v-html="row.getScheduledPublished(item)"></div>
                      <div class="text-muted" v-else v-html="row.getCreatedAt(item)"></div>
                    </div>

                    <div class="ms-auto text-right" v-if="row.isPreDeleted(item)">
                      <div>Выключается...</div>
                      <div class="text-muted" v-html="row.getCreatedAt(item)"></div>
                    </div>

                    <div class="ms-auto text-right" v-if="row.isCanceled(item)">
                      <div>Отменен</div>
                      <div class="text-muted" v-html="row.getCreatedAt(item)"></div>
                    </div>

                    <div class="ms-auto text-right" v-if="row.isDeleted(item)">
                      <div>Опубликовано:</div>
                      <div class="text-muted" v-html="row.getPublishedAt(item)"></div>
                    </div>

                    <div class="ms-auto text-right" v-if="isShowBtnPostRemove(item)">
                      <PostRemove :data="{
                        post_id: row.getId(item),
                        type: 'site',
                      }"
                      @onRemove="onRemovePost" />
                    </div>

                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="post-telegram">
                <template v-if="row.isPrePublished(item) || row.isPreDeleted(item) || row.isCanceled(item)">
                  <div class="ribbon bg-warn">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-alert-circle-filled" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                      <path d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm.01 13l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z" stroke-width="0" fill="currentColor"/>
                    </svg>
                    <span v-if="row.isPrePublished(item)">Публикуется...</span>
                    <span v-if="row.isPreDeleted(item)">Удаляется...</span>
                    <span v-if="row.isCanceled(item)">Отменен</span>
                  </div>
                </template>

                <template v-if="row.isDraft(item)">
                  <div class="ribbon bg-secondary">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-pencil" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <path d="M4 20h4l10.5 -10.5a1.5 1.5 0 0 0 -4 -4l-10.5 10.5v4"></path>
                      <path d="M13.5 6.5l4 4"></path>
                    </svg> <span v-html="row.getCreatedAt(item)"></span>
                  </div>
                </template>

                <template v-if="row.isDeleted(item)">
                  <div class="ribbon bg-red">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-trash" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <line x1="4" y1="7" x2="20" y2="7"></line>
                      <line x1="10" y1="11" x2="10" y2="17"></line>
                      <line x1="14" y1="11" x2="14" y2="17"></line>
                      <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
                      <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
                    </svg> <span v-html="row.getRemovedAt(item)"></span>
                  </div>
                </template>

                <template v-else-if="row.isScheduled(item)">
                  <div class="ribbon bg-yellow">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-clock-hour-8" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <circle cx="12" cy="12" r="9"></circle>
                      <path d="M12 12l-3 2"></path>
                      <path d="M12 7v5"></path>
                    </svg> <span v-html="row.getScheduledPublished(item)"></span>
                  </div>
                </template>

                <template v-else-if="row.isViewScheduledRemoved(item)">
                  <div class="ribbon bg-flickr">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-flame" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 12c2 -2.96 0 -7 -1 -8c0 3.038 -1.773 4.741 -3 6c-1.226 1.26 -2 3.24 -2 5a6 6 0 1 0 12 0c0 -1.532 -1.056 -3.94 -2 -5c-1.786 3 -2.791 3 -4 2z" /></svg>
                    <span v-html="row.getScheduledRemoved(item)"></span>
                  </div>
                </template>

                <template v-if="!row.hasImages(item)">
                  <div class="close-full-show" :class="{ 'right': !hasBadge(item) }" v-if="isMoreShowTelegram(item['id'])" @click.prevent="onMoreHideTelegram(item['id'])">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <path d="M18 6l-12 12"></path>
                      <path d="M6 6l12 12"></path>
                    </svg>
                  </div>
                  <span>
                    <div class="card-img-top card-img-hover" @click.prevent="onMoreShowHideTelegram(item['id'])" :class="{ 'card-img-top_show': isMoreShowTelegram(item['id']) }">
                      <img width="500" :src="getImageStub(row.hasVideo(item))" class="img-card">
                      <div class="card-info">
                        <TypeCommerce :data="{
                          value: row.getTypeCommerce(item)
                        }" />
                        <PostSaleStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                         <PostPointRatingStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <PostPointChainRatingStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <PostRatingStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <CntComments :payload="{
                          cnt_comments: row.getCntComments(item),
                        }" />
                      </div>
                    </div>
                    <div class="card-body post-item" @click="onMoreShowTelegram(item['id'])">
                      <div class="text-muted text-long" v-show="isMoreShowTelegram(item['id'])" v-html="item['content_long']"></div>
                      <div class="text-muted card-text-sh" v-show="!isMoreShowTelegram(item['id'])" v-html="item['content_short']"></div>
                      <div class="my-2">
                        <template v-if="PostPermission.isUpdate(row.getChannelId(item))">
                          <router-link :to="{ name: 'PostUpdate', params: { id: item['id'] } }" class="edit-post toggle-show-post" @click.prevent="onMoreShowTelegram(item['id'])">Редактировать</router-link>
                        </template>
                        <template v-else>
                          <router-link :to="{ name: 'PostView', params: { id: item['id'] } }" class="edit-post toggle-show-post" @click.prevent="onMoreShowTelegram(item['id'])">Смотреть</router-link>
                        </template>
                      </div>
                    </div>
                  </span>
                </template>

                <template v-else-if="row.isTopBlock(item) || row.isNoneBlock(item)">
                  <div class="close-full-show" :class="{ 'right': !hasBadge(item) }" v-if="isMoreShowTelegram(item['id'])" @click.prevent="onMoreHideTelegram(item['id'])">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <path d="M18 6l-12 12"></path>
                      <path d="M6 6l12 12"></path>
                    </svg>
                  </div>
                  <span>
                    <div class="card-img-top card-img-hover" @click.prevent="onMoreShowHideTelegram(item['id'])" :class="{ 'card-img-top_show': isMoreShowTelegram(item['id']) }">
                      <template v-if="row.hasImages(item)">
                        <img :src="getPostImage(item, null, 300)" class="img-card">
                      </template>
                      <template v-else>
                        <img width="500" :src="getImageStub(false)" class="img-card">
                      </template>
                      <div class="card-info">
                        <TypeCommerce :data="{
                          value: row.getTypeCommerce(item)
                        }" />
                        <PostSaleStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <PostPointRatingStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <PostPointChainRatingStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <PostRatingStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <CntComments :payload="{
                          cnt_comments: row.getCntComments(item),
                        }" />
                      </div>
                    </div>

                    <div class="card-body post-item" @click="onMoreShowTelegram(item['id'])">
                      <div class="text-muted text-long" v-show="isMoreShowTelegram(item['id'])" v-html="item['content_long']"></div>
                      <div class="text-muted card-text-sh" v-show="!isMoreShowTelegram(item['id'])" v-html="item['content_short']"></div>
                      <div class="my-2">
                        <template v-if="PostPermission.isUpdate(row.getChannelId(item))">
                          <router-link :to="{ name: 'PostUpdate', params: { id: item['id'] } }" class="edit-post toggle-show-post" @click.prevent="onMoreShowTelegram(item['id'])">Редактировать</router-link>
                        </template>
                        <template v-else>
                          <router-link :to="{ name: 'PostView', params: { id: item['id'] } }" class="edit-post toggle-show-post" @click.prevent="onMoreShowTelegram(item['id'])">Смотреть</router-link>
                        </template>
                      </div>
                    </div>
                  </span>
                </template>

                <template v-else-if="row.isBottomBlock(item)">
                  <div class="close-full-show" :class="{ 'right': !hasBadge(item) }" v-if="isMoreShowTelegram(item['id'])" @click.prevent="onMoreHideTelegram(item['id'])">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-x" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <path d="M18 6l-12 12"></path>
                      <path d="M6 6l12 12"></path>
                    </svg>
                  </div>
                  <span>
                    <div class="card-body post-item" @click="onMoreShowTelegram(item['id'])">
                      <div class="text-muted text-long" v-show="isMoreShowTelegram(item['id'])" v-html="item['content_long']"></div>
                      <div class="text-muted card-text-sh" v-show="!isMoreShowTelegram(item['id'])" v-html="item['content_short']"></div>
                      <div class="my-2">
                        <template v-if="PostPermission.isUpdate(row.getChannelId(item))">
                          <router-link :to="{ name: 'PostUpdate', params: { id: item['id'] } }" class="edit-post toggle-show-post" @click.prevent="onMoreShowTelegram(item['id'])">Редактировать</router-link>
                        </template>
                        <template v-else>
                          <router-link :to="{ name: 'PostView', params: { id: item['id'] } }" class="edit-post toggle-show-post" @click.prevent="onMoreShowTelegram(item['id'])">Смотреть</router-link>
                        </template>
                      </div>
                    </div>
                    <div class="card-img-top card-img-hover" @click.prevent="onMoreShowHideTelegram(item['id'])" :class="{ 'card-img-top_show': isMoreShowTelegram(item['id']) }">
                      <template v-if="row.hasImages(item)">
                        <img :src="getPostImage(item, null, 300)" class="img-card">
                      </template>
                      <template v-else>
                        <img width="500" :src="getImageStub(false)" class="img-card">
                      </template>
                      <div class="card-info">
                        <TypeCommerce :data="{
                          value: row.getTypeCommerce(item)
                        }" />
                        <PostSaleStatistic :data="{
                          post_id: row.getId(item)
                        }" />
                        <PostPointRatingStatistic :data="{
                          post_id: row.getId(item)
                        }" />
                        <PostPointChainRatingStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <PostRatingStatistic :data="{
                          post_id: row.getId(item),
                        }" />
                        <CntComments :payload="{
                          cnt_comments: row.getCntComments(item),
                        }" />
                      </div>
                    </div>
                  </span>
                </template>

                <div class="card-footer">
                  <div class="d-flex align-items-center">
                    <span class="avatar me-3" :style="{ backgroundImage: 'url(' + getImage(item['user_source']['avatar']['host'], item['user_source']['avatar']['name'], 60) + ')' }"></span>
                    <div class="author">
                      <div class="author__name">
                        {{ item['user_source']['username'] }}
                      </div>
                      <div class="channel">
                        <span class="me-2">
                          <Channel :data="{
                            channel_id: row.getChannelId(item)
                          }" />
                        </span>
                      </div>
                    </div>

                    <div class="ms-auto text-right" v-if="row.isPublished(item)">
                      <div>Опубликовано:</div>
                      <div class="text-muted" v-html="row.getPublishedAt(item)"></div>
                    </div>

                    <div class="ms-auto text-right" v-if="row.isPrePublished(item)">
                      <div>Публикуется...</div>
                      <div class="text-muted" v-if="row.getScheduledPublished(item)" v-html="row.getScheduledPublished(item)"></div>
                      <div class="text-muted" v-else v-html="row.getCreatedAt(item)"></div>
                    </div>

                    <div class="ms-auto text-right" v-if="row.isPreDeleted(item)">
                      <div>Удаляется...</div>
                      <div class="text-muted" v-html="row.getCreatedAt(item)"></div>
                    </div>

                    <div class="ms-auto text-right" v-if="row.isCanceled(item)">
                      <div>Отменен</div>
                      <div class="text-muted" v-html="row.getCreatedAt(item)"></div>
                    </div>

                    <div class="ms-auto text-right" v-if="row.isDeleted(item)">
                      <div>Опубликовано:</div>
                      <div class="text-muted" v-html="row.getPublishedAt(item)"></div>
                    </div>

                    <div class="ms-auto text-right" v-if="isShowBtnPostRemove(item)">
                      <PostRemove :data="{
                        post_id: row.getId(item),
                        type: 'telegram',
                      }" @onRemove="onRemovePost" />
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
      <div class="loader-posts">
        <div class="spinner-border" v-show="busy"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent, ref, watch} from "vue"
import Api from "@/modules/post/components/list/services/Api"
import Image from "@/services/Image"
import Helper from "@/services/Helper"
import element from "@/modules/post/components/list/services/element"
import DTBackend from "@/services/DTBackend"
import PostPermission from "@/modules/post/services/Permission"
import PostRemove from "@/modules/post/components/list/components/post_remove/PostRemove"

import PostSaleStatistic from "@/components/statistic/sale/Sale"
import {fill as saleFill} from "@/components/statistic/sale/services/statistic"

import PostPointRatingStatistic from "@/components/statistic/point_rating/PointRating"
import {fill as pointRatingFill} from "@/components/statistic/point_rating/services/statistic"

import PostPointChainRatingStatistic from "@/components/statistic/point_chain_rating/PointChainRating"
import {fill as pointChainRatingFill} from "@/components/statistic/point_chain_rating/services/statistic"

import PostRatingStatistic from "@/components/statistic/rating/Rating"
import {fill as ratingFill} from "@/components/statistic/rating/services/statistic"

import Channel from "@/modules/post/components/list/components/channel/Channel"
import TypeCommerce from "@/modules/post/components/list/components/type_commerce/TypeCommerce"
import PostImage from "@/modules/post/services/PostImage"
import cfg from "@/services/Config"
import CntComments from "@/components/statistic/cnt_comments/Index"
import DT from "@/services/DT"

import IconApi from "@/assets/icons/IconApi"

import {
  notesTypeId,
  salesTypeId,
  promocodeTypeId,
  offersTypeId,
  freeTypeId, foodAndProductsTypeId, banksTypeId, gamesTypeId, raffleTypeId, articlesTypeId
} from "@/modules/post/services/TypeId"
import Notify from "@/services/Notify"

export default defineComponent({
  name: "List",
  components: {
    CntComments,
    TypeCommerce,
    PostRemove,
    PostSaleStatistic,
    PostPointRatingStatistic,
    PostPointChainRatingStatistic,
    PostRatingStatistic,
    Channel,
    IconApi,
  },
  props: {
    query: {
      type: Object,
      required: true
    },
    clearResult: {
      type: Boolean,
      required: true
    }
  },
  setup(props, {emit}) {
    let busy = ref(false)
    let items = ref([])
    let eofItems = ref(false)
    let countItems = ref(0)
    let actionsTelegram = ref([])
    let actionsSite = ref([])

    let row = {
      getId: (item) => {
        return element.getId(item)
      },

      getCreatedAt: (item) => {
        let result, dt, createdAt = element.getCreatedAt(item)

        dt = new DTBackend(createdAt)
        result = dt.get("%D.%M.%y <span>%H:%I</span>")

        return result
      },

      getRemovedAt: (item) => {
        let result, dt, removedAt = element.getRemovedAt(item)

        if (removedAt === null) {
          return ""
        }

        dt = new DTBackend(removedAt)
        result = dt.get("%D.%M.%y <span>%H:%I</span>")

        return result
      },

      getScheduledPublished: (item) => {
        let result, dt, scheduledPublished = element.getScheduledPublished(item)

        if (scheduledPublished === null) {
          return ""
        }

        dt = new DTBackend(scheduledPublished)
        result = dt.get("%D.%M.%y <span>%H:%I</span>")

        return result
      },

      getScheduledRemoved: (item) => {
        let result, dt, scheduledRemoved = element.getScheduledRemoved(item)

        if (scheduledRemoved === null) {
          return ""
        }

        dt = new DTBackend(scheduledRemoved)
        result = dt.get("%D.%M.%y <span>%H:%I</span>")

        return result
      },

      isViewScheduledRemoved: (item) => {
        let scheduledRemoved = element.getScheduledRemoved(item)
        let scheduledPublished = element.getScheduledPublished(item)

        return scheduledRemoved !== null && scheduledPublished === null
      },

      getPublishedAt: (item) => {
        let result, dt, publishedAt = element.getPublishedAt(item)

        if (publishedAt === null) {
          return ""
        }

        dt = new DTBackend(publishedAt)
        result = dt.get("%D.%M.%y <span>%H:%I</span>")

        return result
      },

      getChannelId: (item) => {
        return element.getChannelId(item)
      },

      isDraft: (item) => {
        return element.status.isDraft(item)
      },

      isDeleted: (item) => {
        return element.status.isDeleted(item)
      },

      isScheduled: (item) => {
        return element.status.isScheduled(item)
      },

      isPublished: (item) => {
        return element.status.isPublished(item)
      },

      isPrePublished: (item) => {
        return element.status.isPrePublished(item)
      },

      isPreDeleted: (item) => {
        return element.status.isPreDeleted(item)
      },

      isCanceled: (item) => {
        return element.status.isCanceled(item)
      },

      hasImages: (item) => {
        return element.hasImage(item)
      },

      getFirstImage: (item) => {
        let image = element.getFirstImage(item)

        return {
          host: image.host,
          name: image.name,
        }
      },

      isTopBlock: (item) => {
        return element.imagePosition.isTop(item)
      },

      isBottomBlock: (item) => {
        return element.imagePosition.isBottom(item)
      },

      isNoneBlock: (item) => {
        return element.imagePosition.isNone(item)
      },

      getTypeCommerce: (item) => {
        return element.getTypeCommerce(item)
      },

      hasVideo: (item) => {
        return element.getHasVideo(item)
      },

      getStatus: (item) => {
        return element.getStatus(item)
      },

      getCntComments: (item) => {
        return element.getCntComments(item)
      },

      isChannelSite: (item) => {
        return Helper.inArray([row.getChannelId(item)], [1])
      },

      isChannelTelegram: (item) => {
        return Helper.inArray([row.getChannelId(item)], [2,3,4,5,6,7,8,9,10,11,12])
      },

      getTypeVisibility: (item) => {
        let result = element.getTypeVisibility(item)

        if (result === 1) {
          return "Приватный"
        } else if (result === 2) {
          return "Публичный"
        } else {
          throw new Error("Неверный тип видимости")
        }
      },

      hasPrice: (item) => {
        let newPrice = element.getNewPrice(item)
        let oldPrice = element.getOldPrice(item)

        return newPrice || oldPrice
      },

      getPrice: (item) => {
        let newPrice = element.getNewPrice(item)
        let oldPrice = element.getOldPrice(item)
        let result = ""

        if (newPrice) {
          result += newPrice
        }

        if (oldPrice) {
          let prefix = result ? "/" : ""

          result += prefix + oldPrice
        }

        return result
      },

      hasTimeAction: (item) => {
        let start = element.getTimeActionStart(item)
        let end = element.getTimeActionEnd(item)

        return start || end
      },

      getTimeAction: (item) => {
        let start = element.getTimeActionStart(item)
        let end = element.getTimeActionEnd(item)
        let result = ""

        if (start) {
          let startFormat = new DT(start).startTimeOfDay()
          result += startFormat.get("%D.%M.%y")
        }

        if (end) {
          let prefix = result ? "/" : ""
          let endFormat = new DT(end).startTimeOfDay()
          result += prefix + endFormat.get("%D.%M.%y")
        }

        return result
      },

      hasPromocode: (item) => {
        return row.getPromocode(item) !== "" &&
            row.getPromocode(item) !== null
      },

      getPromocode: (item) => {
        return element.getPromocode(item)
      },

      getPromocodeApi: (item) => {
        return element.getPromocodeApi(item)
      },

      isPromocodeApi: (item) => {
        return row.getPromocodeApi(item) === true
      },

      hasCategoryName: (item) => {
        return row.getCategoryName(item) !== "" &&
            row.getCategoryName(item) !== null
      },

      getCategoryName: (item) => {
        return element.getCategoryName(item)
      },

      hasShop: (item) => {
        return row.getShopName(item) !== "" &&
            row.getShopName(item) !== null &&
            row.getShopName(item) !== undefined
      },

      getShopName: (item) => {
        return element.getShopName(item)
      },

      getShopImage: (item, w, h) => {
        let host = element.getShopImageHost(item)
        let name = element.getShopImageName(item)

        return Image.handle(host, name, w, h)
      },

      getTypeId: (item) => {
        return element.getTypeId(item)
      },

      isTypeNotes: (item) => {
        return row.getTypeId(item) === notesTypeId
      },

      isTypeSales: (item) => {
        return row.getTypeId(item) === salesTypeId ||
            row.getTypeId(item) === offersTypeId ||
            row.getTypeId(item) === freeTypeId ||
            row.getTypeId(item) === foodAndProductsTypeId ||
            row.getTypeId(item) === banksTypeId ||
            row.getTypeId(item) === gamesTypeId ||
            row.getTypeId(item) === raffleTypeId
      },

      isTypePromocode: (item) => {
        return row.getTypeId(item) === promocodeTypeId
      },

      isTypeArticles: (item) => {
        return row.getTypeId(item) === articlesTypeId
      },

      getTitle: (item) => {
        return element.getTitle(item)
      },

      hasActivateLink: (item) => {
        return row.getActivateLink(item) !== "" &&
            row.getActivateLink(item) !== null &&
            row.getActivateLink(item) !== undefined
      },

      getActivateLink: (item) => {
        return element.getActivateLink(item)
      },

      hasCustomLink: (item) => {
        return row.getCustomLink(item) !== "" &&
            row.getCustomLink(item) !== null &&
            row.getCustomLink(item) !== undefined
      },

      getCustomLink: (item) => {
        return element.getCustomLink(item)
      },

      isNotModerate: (item) => {
        return !element.getIsModerate(item)
      },

      isViewModerateNotes: (item) => {
        return row.isPublished(item) && row.isNotModerate(item) && row.isTypeNotes(item)
      },

      hasSaleTypeId: (item) => {
        return Helper.isInt(element.getSaleTypeId(item))
      },

      getSaleTypeIdName: (item) => {
        if (element.getSaleTypeId(item) === 1) {
          return "Новая/старая цена"
        } else if (element.getSaleTypeId(item) === 2) {
          return "Скидка в процентах"
        } else if (element.getSaleTypeId(item) === 3) {
          return "Фиксированная скидка"
        } else if (element.getSaleTypeId(item) === 4) {
          return "Текущая цена"
        } else if (element.getSaleTypeId(item) === 5) {
          return "Бесплатно"
        } else if (element.getSaleTypeId(item) === 6) {
          return "Кастомный ввод"
        } else if (element.getSaleTypeId(item) === 7) {
          return "Подарок"
        }
      },

      getSaleTypeValue: (item) => {
        return element.getSaleTypeValue(item)
      },
    }

    watch(() => props.query, (query) => {
      busy.value = true

      if (props.clearResult) {
        clearResult()
      }

      load(query)
    })

    function clearResult() {
      eofItems.value = false
      countItems.value = 0
      items.value = []
    }

    function load(query, offset = null) {
      if (offset !== null) {
        query.offset = offset
      }

      getApi(query).then((resp) => {
        let data = resp.data

        items.value.push(...data.items)

        if (data.items.length === 0) {
          eofItems.value = true
        }

        countItems.value = data.count

        loadFinal(data.items);
      }).finally(() => {
        busy.value = false

        emit("onRender", {
          "oef_items": eofItems.value,
          "count_items": countItems.value
        })
      })
    }

    function getApi(query) {
      let api = null

      if (
          query.page === "posts" ||
          query.page === "posts_drafts" ||
          query.page === "notes_drafts" ||
          query.page === "promocode_drafts" ||
          query.page === "articles_drafts" ||
          query.page === "notes" ||
          query.page === "posts_not_moderated" ||
          query.page === "notes_not_moderated" ||
          query.page === "promocode" ||
          query.page === "articles"
      ) {
        api = Api.postsChannel(query)
      } else if (query.page === "search") {
        api = Api.posts(query)
      } else if (query.page === "ranking") {
        api = Api.statisticRanking(query)
      } else {
        throw new Error("Страница не определена")
      }

      return api
    }

    function loadFinal(items) {
      saleFill(items, getStatisticTypeId())
      pointRatingFill(items, getStatisticTypeId())
      pointChainRatingFill(items, getStatisticTypeId())
      ratingFill(items, getStatisticTypeId())
    }

    function reload() {
      clearResult()
      load(props.query, 0)
    }

    function getPostImage(item, w = null, h = null) {
      let image = row.getFirstImage(item)

      return Image.handle(image.host, image.name, w, h)
    }

    function getImage(host, name, w = null, h = null) {
      if (host && name) {
        return Image.handle(host, name, w, h)
      }
      return "/assets/static/user/no_image.jpg"
    }

    function getImages(item, w = null, h = null) {
      let images = element.getImages(item)
      let result = []

      Object.entries(images).some(([key]) => {
        result.push(Image.handle(images?.[key]?.host, images?.[key]?.name, w, h))
      })

      return result
    }

    function getImageStub(hasVideo) {
      return PostImage.default(hasVideo)
    }

    function isNotFound(items) {
      return Helper.isEmptyObject(items)
    }

    function onMoreShowTelegram(post_id) {
      actionsTelegram.value[post_id] = {
        show: true
      }
    }

    function onMoreHideTelegram(post_id) {
      actionsTelegram.value[post_id] = {
        show: false
      }
    }

    function onMoreShowHideTelegram(post_id) {
      actionsTelegram.value[post_id] = {
        show: !this.isMoreShowTelegram(post_id)
      }
    }

    function isMoreShowTelegram(post_id) {
      return actionsTelegram.value[post_id]?.show === true
    }

    //

    function onMoreShowSite(post_id) {
      actionsSite.value[post_id] = {
        show: true
      }
    }

    function onMoreHideSite(post_id) {
      actionsSite.value[post_id] = {
        show: false
      }
    }

    function onMoreShowHideSite(post_id) {
      actionsSite.value[post_id] = {
        show: !this.isMoreShowSite(post_id)
      }
    }

    function isMoreShowSite(post_id) {
      return actionsSite.value[post_id]?.show === true
    }

    //

    function getClassBg(item) {
      let status = row.getStatus(item);
      return Helper.getClassBgItems(status)
    }

    function hasBadge(item) {
      return element.status.isDraft(item)
        || element.status.isScheduled(item)
        || element.status.isDeleted(item)
    }

    function onRemovePost(payload) {
      if (payload === true) {
        reload()
      }
    }

    function isShowBtnPostRemove(item) {
      return row.isDraft(item) && PostPermission.isDelete(row.getChannelId(item))
    }

    function getStatisticTypeId() {
      return cfg._("statistic", "types", "post")
    }

    function getClassByTypeId(item) {
      switch (row.getTypeId(item)) {
        case notesTypeId:
          return "type-notes"
        case salesTypeId:
          return "type-sales"
        case promocodeTypeId:
          return "type-promocode"
        case offersTypeId:
          return "type-sales"
      }
    }

    function onMarkPostModerate(postId) {
      if (confirm("Вы действительно хотите промодерировать пост?")) {
        Api.siteNotesMarkModerated({
          post_id: postId
        }).then(() => {
          Notify.success("Проверно")
          reload()
        })
      }
    }

    return {
      busy,
      items,
      getPostImage,
      getImage,
      getImages,
      isNotFound,
      onMoreShowTelegram,
      onMoreHideTelegram,
      isMoreShowTelegram,
      onMoreShowHideTelegram,
      onMoreShowSite,
      onMoreHideSite,
      isMoreShowSite,
      onMoreShowHideSite,
      getImageStub,
      getClassBg,
      hasBadge,
      row,
      PostPermission,
      onRemovePost,
      isShowBtnPostRemove,
      getStatisticTypeId,
      getClassByTypeId,
      onMarkPostModerate,
    }
  }
})
</script>

<style src="./css/style.css" scoped></style>
<style src="./css/telegram.css" scoped></style>
<style src="./css/site.css" scoped></style>
<style src="./css/promocode.css" scoped></style>
